module.exports = __webpack_public_path__ + "img/parisandco.2b9bb604.png";